import { render, staticRenderFns } from "./AccountWithdrawalApplyListTable.vue?vue&type=template&id=2006a550"
import script from "./AccountWithdrawalApplyListTable.vue?vue&type=script&lang=js"
export * from "./AccountWithdrawalApplyListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports